
import { Component, Inject  } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router, NavigationEnd } from '@angular/router';
import { Location } from "@angular/common";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { SDContactsToDisplay } from '@tecommon/structures/structures';
import { Globals } from '../global/globals';
@Component({
    selector: 'te-footer',
    templateUrl: 'teFooter.component.html',
    standalone: false
})
export class TEFooterComponent
{
    public errorMessage: string;
    constructor(private readonly http: HttpClient, private location: Location, private readonly dialog: MatDialog, private globals: Globals,
        private router: Router) {

    }
    //open for model popup
    public getSDContacts(): void {

        const dialogRef = this.dialog.open(SdContactDialogComponent, {
            disableClose: false, panelClass:'custom-dialog-container'
        });
        dialogRef.updatePosition({ top: '40px' });       
    }
}


import { TranslateService } from '@ngx-translate/core';
import { LocalStorage } from '../localStorage/localStorage.service';
declare var document: any;
@Component({
    selector: 'sd-Contact-Dialog',
    templateUrl: 'sdContact.dialog.html',
    standalone: false
})
export class SdContactDialogComponent {

    public isLoading: boolean;
    public languageCode: string;
    public dataSource: Array<SDContactsToDisplay>;
    public filteredDataSource: Array<SDContactsToDisplay> = [];
    public uniqueCountries: string[];
    public selectedCountry: string;

    public userId: string;
    public lastUpdatedDate: string;
    public lastUpdated: any;

    public loadingStatus: boolean;
    public successMessage: string;
    public errorMessage: string;

    public isMobile: boolean;
    private wasMobile: boolean; // Track the previous mobile state

    displayedColumns: string[] = ['u_country', 'u_support_desk', 'u_phone_number'];

    constructor(
        private readonly http: HttpClient,
        public dialogRef: MatDialogRef<SdContactDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private readonly translate: TranslateService,
        private readonly localStorage: LocalStorage,
        private readonly countryDialog: MatDialog) {

        this.loadingStatus = true;
        this.isMobile = window.innerWidth <= 768;
        this.wasMobile = this.isMobile;  // Initial check

        // Subscribe to window resize events
        window.addEventListener('resize', this.checkScreenSize.bind(this));

        this.http.get<SDContactsToDisplay[]>("/api/site/SDContacts").subscribe(result => {
            this.dataSource = result;
            this.filteredDataSource = result;
            this.lastUpdatedDate = result[0].sys_updated_on;

            // Populate unique country list for dropdown
            this.uniqueCountries = Array.from(new Set(result.map(contact => contact.u_country)));

            this.loadingStatus = false;           
        },
            error => {
                console.log(error.error.message);
                this.loadingStatus = false;
            });
    }

    openCountryDialog(): void {
        const dialogRef = this.countryDialog.open(CountryDialogComponent, {
            disableClose: true,
            data: this.uniqueCountries// Pass the list of countries to the dialog            
        });

        dialogRef.afterClosed().subscribe(selectedCountry => {
            if (selectedCountry) {
                this.selectedCountry = selectedCountry;
                this.applyFilter();
            }
        });
    }

    // Method to check screen size and update the isMobile flag
    checkScreenSize() {
        this.isMobile = window.innerWidth <= 768;

        // Check if transitioning from mobile to desktop
        if (this.wasMobile && !this.isMobile) {
            this.resetFilter();  // Reset the filter when switching back to desktop
        }

        // Update the previous state
        this.wasMobile = this.isMobile;
    }

    applyFilter() {
        if (this.selectedCountry) {
            this.filteredDataSource = this.dataSource.filter(contact => contact.u_country === this.selectedCountry);
        } else {
            this.filteredDataSource = this.dataSource;
        }
    }

    resetFilter() {
        this.selectedCountry = null;  // Clear the selected country
        this.filteredDataSource = this.dataSource;  // Reset the table to show all data
    }

    // Unsubscribe to avoid memory leaks when component is destroyed
    ngOnDestroy() {
        window.removeEventListener('resize', this.checkScreenSize);
    }
}



@Component({
    selector: 'country-dialog',
    templateUrl: './country-dialog.component.html',
    standalone: false
})
export class CountryDialogComponent {
    public selectedCountry: string;

    constructor(
        public dialogRef: MatDialogRef<CountryDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public countries: string[],
        private readonly translate: TranslateService
    ) { }

    selectCountry() {
        this.dialogRef.close(this.selectedCountry);  // Pass selected country back to the original dialog
    }
}


